import React from "react";
import { Presenting, Over } from "./pages";
import _ from "lodash";
import { connect } from "react-redux";

function SlideKickHomepage(props) {
  const game_obj = _.get(props, "gameReducer.roomObj");
  const status = _.get(game_obj, "game_state.status");
  const param = _.get(props, "paramsReducer.gameObj");
  return (
    <div className="w-100 slidekick-tabletop-homepage">
      {status === "Presenting" ? (
        <Presenting param={param.presenting} />
      ) : (
        <Over param={param.over} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SlideKickHomepage);
